import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "@repo/ui";
import { configurationApi } from "~/api";
import { getErrorMessage } from "~/hooks/helpers";

const workflowsQueryKey = configurationApi.queryOptions("get", "/api/Workflow").queryKey;

export type Props = {
  unLinkStatus: (workflowId: number, procedureId: number, statusCode: number) => Promise<unknown>;
  isUnlinking: boolean;
  isSuccess: boolean;
  isError: boolean;
};

export const useUnlinkActionStatus = (): Props => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  const unlinkStatusesMutation = configurationApi.useMutation(
    "delete",
    "/api/workflow/{workflowId}/Procedure/{procedureId}/status/{statusCode}",
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: workflowsQueryKey });
      },
      onError: (error) => {
        showToast("error", getErrorMessage(error, "Failed to unlink action status"), "Error");
      },
    }
  );

  const unLinkStatus = async (workflowId: number, actionId: number, statusCode: number) => {
    return unlinkStatusesMutation.mutateAsync({
      params: { path: { workflowId, procedureId: actionId, statusCode } },
    });
  };

  return {
    unLinkStatus: unLinkStatus,
    isUnlinking: unlinkStatusesMutation.isPending,
    isSuccess: unlinkStatusesMutation.isSuccess,
    isError: unlinkStatusesMutation.isError,
  };
};
